module.exports = __webpack_public_path__ + "static/img/img (10).aabf9861.jpg";